module.exports = __webpack_public_path__ + "static/lunaleaps-2c7f6b23df11ea24817d24fe4cb9f654.jpg";